import { useCountries, userInfoDecodedDataAtom } from '@capsicum/common';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { useUserCountryQueries } from '../data-access/queries/useUserCountryQueries';

export const useUserPrefilledData = () => {
	const { getCountryBy } = useCountries();
	const { data: userIPCountry, isLoading: isUserCountriesQueryLoading } = useUserCountryQueries();
	const userInfoData = useAtomValue(userInfoDecodedDataAtom);

	const prefilledCountry = useMemo(
		() => (userInfoData?.country ? getCountryBy(userInfoData?.country, 'name') : userIPCountry),
		[getCountryBy, userIPCountry, userInfoData?.country]
	);

	return {
		isUserCountriesQueryLoading,
		prefilledBirthDate: userInfoData?.dob || '',
		prefilledCountry,
		prefilledEmail: userInfoData?.email || '',
		prefilledPhoneNumber: userInfoData?.phoneNumber || '',
		prefilledUsername: userInfoData?.username || ''
	};
};
